import { defineStore } from 'pinia';
import { substituiVazio } from '@/helper/funcoes';

export const useEnderecoStore = defineStore('location', {
    state: () => ({
        currentLocation: null,
        dadosEndereco: {
            logradouro: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
            referencia: "",
            latitude: "",
            longitude: "",
        },
        modal: {
            aberto: false,
            tipoEndereco: '',
            segundaSaida: false,
            corrigir: false
        },
        loading: false
    }),

    actions: {
        abrirModalLocalizacao(payload) {
            this.modal = {
                aberto: true,
                tipoEndereco: payload.tipoEndereco,
                segundaSaida: payload.segundaSaida || false,
                corrigir: payload.corrigir || false
            };

            if (payload.endereco) {
                this.dadosEndereco = { ...this.dadosEndereco, ...payload.endereco };
            }
        },

        fecharModalEndereco() {
            this.modal.aberto = false;
            this.limparDadosEndereco();
        },

        atualizarDadosEnderecos(novoEndereco) {
            this.dadosEndereco = { ...this.dadosEndereco, ...novoEndereco };
        },

        limparDadosEndereco() {
            this.dadosEndereco = {
                logradouro: "",
                numero: "",
                bairro: "",
                cidade: "",
                estado: "",
                referencia: "",
                latitude: "",
                longitude: "",
            };
        },

        async obterLocalizacaoAtual() {
            this.loading = true;
            try {
                const position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                });

                const endereco = await this.obterEnderecoPelaCoordenada(position.coords);
                this.atualizarDadosEnderecos(endereco);

                return endereco;
            } catch (error) {
                console.error("Error getting location >> ", error);
                throw Error("Erro ao obter a localização atual");
            } finally {
                this.loading = false;
            }
        },

        async obterEnderecoPelaCoordenada({ latitude, longitude }) {
            // eslint-disable-next-line no-undef
            const geocoder = new google.maps.Geocoder();
            const data = await geocoder.geocode({
                location: {
                    lat: latitude,
                    lng: longitude
                }
            }).then((response) => {
                if (response.results[0]) {
                    return response.results[0];
                }
            });

            const endereco = this.tratarEnderecoGoogle(data.address_components);

            return {
                logradouro: substituiVazio(endereco.logradouro, '-'),
                numero: '',
                bairro: substituiVazio(endereco.bairro, '-'),
                cidade: substituiVazio(endereco.cidade, '-'),
                estado: substituiVazio(endereco.estado, '-'),
                referencia: '',
                latitude: substituiVazio(data.geometry.location.lat(), '-'),
                longitude: substituiVazio(data.geometry.location.lng(), '-')
            };
        },

        tratarEnderecoGoogle(endereco) {
            let logradouro = '';
            let bairro = '';
            let cidade = '';
            let estado = '';
            
            const posicoesLogradouro = ['street_address', 'road', 'route'];
            const posicoesBairro = ['sublocality_level_1', 'administrative_area_level_4', 'neighbourhood'];
            const posicoesCidade = ['administrative_area_level_2', 'administrative_area_level_2', 'locality', 'city_district', 'city', 'town'];
            const posicoesEstado = ['state', 'administrative_area_level_1'];
            
            endereco.forEach((item) => {
                if (posicoesLogradouro.includes(item.types[0])) {
                    logradouro = item.long_name;
                }
                if (posicoesBairro.includes(item.types[0])) {
                    bairro = item.long_name;
                }
                if (posicoesCidade.includes(item.types[0])) {
                    cidade = item.long_name;
                }
                if (posicoesEstado.includes(item.types[0])) {
                    estado = item.long_name;
                }
            });

            return { logradouro, bairro, cidade, estado };
        }
    },

    getters: {
        coordenadasMapa: (state) => {
            if (state.dadosEndereco.latitude && state.dadosEndereco.longitude) {
                return [{
                    lat: state.dadosEndereco.latitude,
                    long: state.dadosEndereco.longitude
                }];
            }
            return [];
        },
    }
});